import React from "react";
import {
  trioMutualExclusionRecoveryModeFromApiFlags,
  shouldDisableIntruderForActiveProducts,
} from "./trioMutualExclusionRecoveryMode";

export const handleCheckForDisabledProducts = (
  productsData: any,
  setSelectedGroups: any,
  allowConcurrentLineCrossingIntruderProducts = false
) => {
  const productsActive = {
    intruder: false,
    bike: false,
    vehicle: false,
    intruder_plus: false,
    bike_plus: false,
    vehicle_plus: false,
    intruder_motion: false,
    bike_motion: false,
    vehicle_motion: false,
    intruder_line_crossing: false,
    vehicle_line_crossing: false,
  };

  productsData.forEach((product: any) => {
    const metrics: any = product.metrics;
    for (const key in metrics) {
      if (key === "intruder") {
        productsActive.intruder = metrics[key].active;
      } else if (key === "intruder_plus") {
        productsActive.intruder_plus = metrics[key].active;
      } else if (key === "bike") {
        productsActive.bike = metrics[key].active;
      } else if (key === "bike_plus") {
        productsActive.bike_plus = metrics[key].active;
      } else if (key === "vehicle") {
        productsActive.vehicle = metrics[key].active;
      } else if (key === "vehicle_plus") {
        productsActive.vehicle_plus = metrics[key].active;
      } else if (key === "intruder_motion") {
        productsActive.intruder_motion = metrics[key].active;
      } else if (key === "bike_motion") {
        productsActive.bike_motion = metrics[key].active;
      } else if (key === "vehicle_motion") {
        productsActive.vehicle_motion = metrics[key].active;
      } else if (key === "intruder_line_crossing") {
        productsActive.intruder_line_crossing = metrics[key].active;
      } else if (key === "vehicle_line_crossing") {
        productsActive.vehicle_line_crossing = metrics[key].active;
      }
    }
  });

  const baseIntruderActive =
    productsActive.intruder || productsActive.bike || productsActive.vehicle;
  const intruderPlusActive =
    productsActive.intruder_plus ||
    productsActive.bike_plus ||
    productsActive.vehicle_plus;
  const motionPlusActive =
    productsActive.intruder_motion ||
    productsActive.bike_motion ||
    productsActive.vehicle_motion;
  const lineCrossingActive =
    productsActive.intruder_line_crossing ||
    productsActive.vehicle_line_crossing;

  const trioConflictFromApi = trioMutualExclusionRecoveryModeFromApiFlags(
    baseIntruderActive,
    motionPlusActive,
    lineCrossingActive,
    allowConcurrentLineCrossingIntruderProducts
  );

  setSelectedGroups((previousState: any) => {
    const updatedSelectedGroups = { ...previousState };
    updatedSelectedGroups.intruderPlus.disabled = baseIntruderActive;
    updatedSelectedGroups.intruder.disabled =
      intruderPlusActive ||
      (!trioConflictFromApi &&
        shouldDisableIntruderForActiveProducts(
          motionPlusActive,
          lineCrossingActive,
          allowConcurrentLineCrossingIntruderProducts
        ));
    updatedSelectedGroups.intruder.intruder = productsActive.intruder;
    updatedSelectedGroups.intruder.bike = productsActive.bike;
    updatedSelectedGroups.intruder.vehicle = productsActive.vehicle;
    updatedSelectedGroups.intruderPlus.intruder_plus =
      productsActive.intruder_plus;
    updatedSelectedGroups.intruderPlus.bike_plus = productsActive.bike_plus;
    updatedSelectedGroups.intruderPlus.vehicle_plus =
      productsActive.vehicle_plus;
    return updatedSelectedGroups;
  });
};
